module.exports = __webpack_public_path__ + "img/14.e63eb065.jpg";